// Add setting type constants
export const SETTING_TYPES = {
  DEFAULT: 1,
  EXTENDED: 2,
  MARAFON_1: 3,
  MARAFON_2: 4
};
  
export const SETTING_TYPE_LABELS = {
  [SETTING_TYPES.DEFAULT]: 'Default',
  [SETTING_TYPES.EXTENDED]: 'Extended',
  [SETTING_TYPES.MARAFON_1]: 'Marathon 1',
  [SETTING_TYPES.MARAFON_2]: 'Marathon 2',
};
  
export const DATE_COMPARISON_LABELS = {
  0: 'None',
  1: '== Last marathon',
  2: '<= Last marathon',
  3: '>= Last marathon',
  4: '== Start date',
  5: '<= Start date',
  6: '>=  Start date',
};

export const DATE_COMPARISON_COM_LABELS = {
  0: 'N/A',
  1: '== LM',
  2: '<= LM',
  3: '>= LM',
  4: '== SD',
  5: '<= SD',
  6: '>= SD',
};

// Add constants for the tri-state values
export const TRI_STATE = {
  NA: 0,
  YES: 1,
  NO: 2
};

export const TRI_STATE_LABELS = {
  [TRI_STATE.NA]: 'N/A',
  [TRI_STATE.YES]: 'Yes',
  [TRI_STATE.NO]: 'No'
};
  